import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [] });

  const refresh = useCallback(async () => {
    if (!user || user.role !== "customer") { setCart({ items: [] }); return; }
    try {
      const { data } = await api.get("/cart");
      setCart(data);
    } catch { setCart({ items: [] }); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (product_id, quantity = 1) => {
    const { data } = await api.post("/cart/add", { product_id, quantity });
    setCart(data);
  };
  const update = async (product_id, quantity) => {
    const { data } = await api.post("/cart/update", { product_id, quantity });
    setCart(data);
  };
  const clear = async () => { await api.delete("/cart"); setCart({ items: [] }); };

  const count = (cart.items || []).reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ cart, count, add, update, clear, refresh }}>
      {children}
    </CartContext.Provider>
  );
}
